export default "/shell-stargate.26bb6c0a7518d207581a622d819f59cd.png";